import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.find-index.js";
import { deepClone, secondsToHMS, timeFormat } from "../../../utils/utils";
import moment from "moment";
export default {
  name: "snoreData",
  props: {
    more: {
      type: Boolean,
      default: true
    },
    snoreList: {
      type: Array
    },
    snoreDetail: {
      type: Object
    }
  },
  data: function data() {
    return {
      imgVolumeUp: require("../../../assets/imgs/volume_up.svg"),
      imgVolumeDown: require("../../../assets/imgs/volume_down.svg"),
      imgVolumeMute: require("../../../assets/imgs/volume_mute.svg"),
      currentAudioSrc: "https://samplelib.com/lib/preview/mp3/sample-15s.mp3",
      list: [{
        id: 1,
        startSnore: 1700103282838,
        url: require("../../../assets/audio/sample-3s.mp3")
      }, {
        id: 2,
        startSnore: 1700103283838,
        url: require("../../../assets/audio/sample-6s.mp3")
      }, {
        id: 3,
        startSnore: 1700103284838,
        url: require("../../../assets/audio/sample-12s.mp3")
      }, {
        id: 4,
        startSnore: 1700103284838,
        audioUrl: require("../../../assets/audio/sample-12s.mp3")
      }, {
        id: 5,
        startSnore: 1700103284838,
        audioUrl: require("../../../assets/audio/sample-12s.mp3")
      }, {
        id: 6,
        startSnore: 1700103284838,
        audioUrl: require("../../../assets/audio/sample-12s.mp3")
      }, {
        id: 7,
        startSnore: 1700103284838,
        audioUrl: require("../../../assets/audio/sample-12s.mp3")
      }],
      isIos: sessionStorage.getItem("isiOS") && sessionStorage.getItem("isiOS") !== "false",
      isPlayId: null,
      isInWaitPlay: false,
      isInWaitPause: false,
      isH5Playing: false,
      isPlayType: 0,
      showLength: 3,
      maxShowLength: 6,
      timer: null
    };
  },
  computed: {
    finalSnoreList: function finalSnoreList() {
      var result = deepClone(this.snoreList);

      if (result && result.length) {
        result.sort(function (a, b) {
          return a.startSnore - b.startSnore;
        });
        result.forEach(function (item) {
          item.localPathId = item.localPathId.toString();
        });
      }

      return result; // let sleepStartMillis = this.snoreDetail.sleepStartMillis;
      // let sleepEndMillis = this.snoreDetail.sleepEndMillis;
      // console.log(moment(sleepStartMillis).format('YYYY-MM-DD hh:mm:ss'),
      //     moment(sleepEndMillis).format('YYYY-MM-DD hh:mm:ss'))
      // // prd规则
      // // 1、优先取睡觉1小时后且起床前半小时之前（兜底：若取不到入睡和起床时间，则优先时段默认为当地时间1:00-6:00）的离60秒最近的鼾声音频；
      // // 2、若满足1条件的鼾声音频不足6段，则在睡觉1小时内和睡醒前半小时内的时段查找离60秒最近的鼾声音频；
      //
      // if(result && result.length > 1) {
      //     // 1.判断是否满足prd规则，若满足则按照规则取数据
      //     if (moment(sleepEndMillis).diff(moment(sleepStartMillis), 'minutes') > 1.5 * 60) {
      //         let finalResult = []
      //         let startMills = moment(sleepStartMillis).add(60, 'minutes');
      //         let endMills = moment(sleepEndMillis).subtract(30, 'minutes');
      //         // 1.1 取满足条件1的鼾声数组【中间时间段的鼾声数据】
      //         const middleSnoreLists = result.filter(item => {
      //             return !(item.endSnore < startMills || item.startSnore > endMills);
      //         });
      //         // 1.1.1 按最接近1分钟进行排序
      //         middleSnoreLists.sort((a, b)=>{
      //             const diffA = Math.abs(a.totalTime - 60 * 1000);
      //             const diffB = Math.abs(b.totalTime - 60 * 1000);
      //             return diffA - diffB;
      //         })
      //         // 2.取前6条
      //         finalResult = middleSnoreLists.slice(0, Math.min(middleSnoreLists.length, 6));
      //
      //         // 获取前后时间段的鼾声数据
      //         const startOrEndSnoreLists = result.filter(item => {
      //             return item.endSnore < startMills || item.startSnore > endMills;
      //         });
      //         // 3. 不足6条数据，按照prd规则2再继续取数据
      //         if(finalResult.length < 6 && startOrEndSnoreLists.length) {
      //             const startOrEndSnoreLists = result.filter(item => {
      //                 return item.endSnore < startMills || item.startSnore > endMills;
      //             });
      //             startOrEndSnoreLists.sort((a, b)=>{
      //                 const diffA = Math.abs(a.totalTime - 60 * 1000);
      //                 const diffB = Math.abs(b.totalTime - 60 * 1000);
      //                 return diffA - diffB;
      //             })
      //             let len = 6 - finalResult.length;
      //             let result2 = startOrEndSnoreLists.slice(0, Math.min(startOrEndSnoreLists.length, len));
      //             finalResult = [...finalResult, ...result2]
      //         }
      //         // 4.按时间排序
      //         finalResult.sort((a,b)=>{
      //             return a.startSnore - b.startSnore;
      //         })
      //         return finalResult;
      //
      //
      //     } else {
      //         // 1.按最接近1分钟进行排序
      //         result.sort((a, b)=>{
      //             const diffA = Math.abs(a.totalTime - 60 * 1000);
      //             const diffB = Math.abs(b.totalTime - 60 * 1000);
      //
      //             return diffA - diffB;
      //             // return b.totalTime - a.totalTime;
      //         })
      //         // 2.取前6条
      //         result = result.slice(0, Math.min(result.length, 6));
      //         // 3.按时间排序
      //         result.sort((a,b)=>{
      //             return a.startSnore - b.startSnore;
      //         })
      //     }
      // }
      // console.log('finalSnoreList', result)
      // return result;
    }
  },
  created: function created() {
    var _this = this;

    window.startH5AudioAnimation = function (localPathId) {
      console.log('app调用h5开始播放动画', localPathId);

      _this.onAppAudioPlay({
        localPathId: localPathId
      });
    };

    window.endH5AudioAnimation = function (localPathId) {
      console.log('app调用h5暂停播放动画', localPathId);

      _this.onAppAudioEnd(localPathId);
    };

    window.playAppAudioError = function (localPathId) {
      console.log('app播放异常', localPathId);

      _this.onAppAudioPlayError();
    };
  },
  beforeUnmount: function beforeUnmount() {
    this.endAudioPlayBeforeOut();
  },
  methods: {
    timeFormat: timeFormat,
    getTimeRangeSeconds: function getTimeRangeSeconds(item) {
      var seconds = Number((item.endSnore - item.startSnore) / 1000).toFixed(0);
      var timeInfos = secondsToHMS(seconds);
      var finalRes = "".concat(timeInfos.hour ? timeInfos.hour + 'h' : '') + "".concat(timeInfos.minute ? timeInfos.minute + 'm' : '') + "".concat(timeInfos.seconds ? timeInfos.seconds + 's' : '');
      return finalRes;
    },
    showMore: function showMore() {
      this.showLength = this.maxShowLength;
    },
    showNoAudioTip: function showNoAudioTip() {
      this.$toast(this.$t("message.snore.noAudioTip"));
    },
    play: function play(item, index) {
      var _this2 = this;

      console.log('播放item', item); // 等待 audio 元素加载完成再播放

      if (!item.url && !item.localPathId) {
        this.showNoAudioTip();
      } else if (this.isInWaitPlay || this.isInWaitPause) {
        console.log(this.isInWaitPlay ? '正在等待播放中...,无需再次点击' : '正在等待暂停中...,无需再次点击');
      } else if (this.isPlayId == item.localPathId) {
        console.log('暂停播放', item.localPathId);
        this.isInWaitPause = true; // 暂停播放

        if (this.isH5Playing) {
          console.log('h5暂停播放=》', item.localPathId, 'url', item.url);
          var _currentAudioRef = this.$refs.audios[index]; // console.log('currentAudioRef', currentAudioRef)

          this.onH5AudioEnd();

          _currentAudioRef.pause();
        } else if (this.isIos) {
          console.log('ios暂停播放=》', item.localPathId);
          window.webkit.messageHandlers.pauseAppAudio.postMessage(item.localPathId);
        } else {
          console.log('安卓暂停播放=》', item.localPathId);
          window.MobvoiJSBridge.pauseAppAudio(item.localPathId);
        }
      } else {
        this.isPlayType = 0; // 开始播放

        if (this.isH5Playing) {
          console.log('h5开始播放', item.url);
          var result = currentAudioRef.play();

          if (result) {
            result.then(function (res) {
              console.log('成功', res);
            }).catch(function (e) {
              console.log('h5播放失败111', e);

              _this2.showNoAudioTip();
            });
          }
        } else if (this.isIos) {
          this.isInWaitPlay = true;
          this.isPlayId = item.localPathId;
          console.log('ios开始播放', item.localPathId);
          window.webkit.messageHandlers.playAppAudio.postMessage(item.localPathId);
        } else {
          this.isInWaitPlay = true;
          this.isPlayId = item.localPathId;
          console.log('android开始播放', item.localPathId);
          window.MobvoiJSBridge.playAppAudio(item.localPathId);
        }
      }
    },
    onH5AudioPlay: function onH5AudioPlay(item) {
      console.log('h5 audio开始播放......');
      this.isH5Playing = true;
      this.isInWaitPlay = false;
      this.isPlayId = item.localPathId;
      this.startAnimation(item.localPathId);
    },
    startAnimation: function startAnimation(localPathId) {
      var _this3 = this;

      this.stopInterval();
      this.startInterval(function () {
        var val = Number(_this3.isPlayType);

        if (val < 2) {
          _this3.isPlayType = val + 1;
        } else {
          _this3.isPlayType = 0;
        }
      }, 500, function () {
        return _this3.isPlayId && _this3.isPlayId == localPathId && !_this3.isInWaitPlay;
      });
    },
    startInterval: function startInterval(callback, delay, condition) {
      var _this4 = this;

      if (condition()) {
        callback();
        this.timer = setTimeout(function () {
          _this4.startInterval(callback, delay, condition);
        }, delay);
      }
    },
    stopInterval: function stopInterval() {
      if (this.timer) {
        console.log('停止定时器');
        this.isPlayType = 0;
        clearTimeout(this.timer);
      }
    },
    playH5Audio: function playH5Audio(currentAudioRef) {
      var _this5 = this;

      console.log('app播放失败后，h5 audio开始播放......', currentAudioRef);
      var result = currentAudioRef.play();
      console.log('result', result);

      if (result) {
        result.then(function (res) {
          console.log('成功', res);
        }).catch(function (e) {
          console.log('h5播放失败111', e);
          _this5.isH5Playing = false;
          _this5.isInWaitPlay = false;
          _this5.isInWaitPause = false;
          _this5.isPlayId = 0;

          _this5.showNoAudioTip();
        });
      }
    },
    onH5AudioPause: function onH5AudioPause() {
      this.isInWaitPause = false;
      this.onH5AudioEnd();
    },
    onH5AudioEnd: function onH5AudioEnd() {
      this.isH5Playing = false;
      this.isInWaitPause = false;
      this.isPlayId = 0;
      this.stopInterval();
    },
    onAppAudioEnd: function onAppAudioEnd() {
      this.isH5Playing = false;
      this.isInWaitPause = false;
      this.isPlayId = 0;
      this.stopInterval();
    },
    onAppAudioPlay: function onAppAudioPlay(item) {
      this.isH5Playing = false;
      this.isInWaitPlay = false;
      this.isPlayId = item.localPathId;
      this.startAnimation(item.localPathId);
    },
    onAppAudioPlayError: function onAppAudioPlayError() {
      var _this6 = this;

      // 等待 audio 元素加载完成再播放
      var index = this.finalSnoreList.findIndex(function (item) {
        return item.localPathId == _this6.isPlayId;
      });

      if (index !== -1) {
        var _currentAudioRef2 = this.$refs.audios[index];
        console.log('index', index);
        this.playH5Audio(_currentAudioRef2);
      } else {
        this.onAppAudioEnd();
      }
    },
    endAudioPlayBeforeOut: function endAudioPlayBeforeOut() {
      var _this7 = this;

      console.log('离开界面前，检查断开音频');

      if (this.isH5Playing && this.isPlayId) {
        var index = this.finalSnoreList.findIndex(function (item) {
          return item.localPathId == _this7.isPlayId;
        });
        if (index === -1) return;
        var _currentAudioRef3 = this.$refs.audios[index];

        if (_currentAudioRef3) {
          _currentAudioRef3.pause();

          this.onH5AudioEnd();
        }
      } else if (this.isIos && this.isPlayId) {
        window.webkit.messageHandlers.pauseAppAudio.postMessage(this.isPlayId);
        this.onH5AudioEnd();
      } else if (!this.isIOS && this.isPlayId) {
        window.MobvoiJSBridge.pauseAppAudio(this.isPlayId);
        this.onH5AudioEnd();
      }
    }
  }
};